import translations from "../../translations/resources/en-GB.json";
export var INTERNAL_TOOL_TABS = {
    INDOOR_MAPS: translations.data["venonboard.internalToolsTab1"],
    MAP_ORDERS: translations.data["venonboard.internalToolsTab3"],
    MAP_COLLECTION: translations.data["venonboard.internalToolsTab2"],
};
export var ButtonText = {
    MIGRATE_MAP: translations.data["venonboard.form.migrateButton"],
    ORDER_3D_MAP: "Order 3D map",
};
